export default __webpack_public_path__ + "static/media/sweat-tool.cfe459cf.PNG";